import { useCompanyProfile } from '@/account';
import { computed } from 'vue';
import {
	PhoneSystemItemName,
	ProductAlias,
	SubscriptionName,
	SubscriptionStatus
} from './types';
import { useBilling } from './composition';

export function useVirtualMailboxSystem() {
	const state = useBilling();
	const { isPaidAccount, isManager } =
		useCompanyProfile();

	const virtualMailboxSubscription = computed(() => {
		if (isPaidAccount.value) {
			const quantity =
				state.currentSubscription.value?.items
					.filter(
						(sub) =>
							sub.productAlias ===
							ProductAlias.virtualMailSystem
					)
					.reduce(
						(acc, curr) => acc + curr.quantity,
						0
					);

			return { quantity };
		}

		return { quantity: 1 };
	});

	const hasVirtualMailboxSystem = computed(
		() =>
			!isPaidAccount.value ||
			!!virtualMailboxSubscription.value
	);

	return {
		virtualMailboxSubscription,
		hasVirtualMailboxSystem,
		isVirtualMailboxActive: computed(() => {
			return (
				!isPaidAccount.value ||
				state.currentSubscription.value
					?.stripe_status ===
					SubscriptionStatus.active
			);
		}),
		totalAvailablePhoneNumbers: computed(
			() =>
				virtualMailboxSubscription.value
					?.quantity || 0
		)
	};
}
